module.exports = __webpack_public_path__ + "img/emoji_78.4f5202b0.png";